export default __webpack_public_path__ + "Nygren_Resume.pdf";